const { registerBlockType } = wp.blocks;

import Editor from './Editor';
import Save from './Save';

registerBlockType('about-us-cards-card/block', {
  title: 'Quem somos cards',
  description: '',
  icon: 'saved',
  category: 'design',
  attributes: {
    cardImage: {
      type: 'object',
      default: {
        id: '',
        src: '',
        alt: '',
      },
    },
  },

  getEditWrapperProps() {
    return {
      'data-align': 'full',
    };
  },

  edit: (props) => <Editor {...props} />,
  save: (props) => <Save {...props} />,
});
